import { render } from "./CategoryAndDocumentMaintenance.vue?vue&type=template&id=2dd76097&scoped=true&ts=true"
import script from "./CategoryAndDocumentMaintenance.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryAndDocumentMaintenance.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryAndDocumentMaintenance.vue?vue&type=style&index=0&id=2dd76097&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd76097"],['__file',"src/components/scan/regulations/CategoryAndDocumentMaintenance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2dd76097"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2dd76097', __exports__)) {
    console.log('reload')
    api.reload('2dd76097', __exports__)
  }
  
  module.hot.accept("./CategoryAndDocumentMaintenance.vue?vue&type=template&id=2dd76097&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('2dd76097', render)
  })

}


export default __exports__